import {getCLS, getFID, getLCP, getFCP, getTTFB} from 'web-vitals'
import now from 'performance-now'
import mobile from 'is-mobile'

import log from 'uix/logging'
import {values, isNil, iterItems} from 'ldash'

import {isSSR} from './dom'

// always send (incomplete) vitals after N Secs
const FORCE_SECS = 10

export const VITALS = {
  // Time To First Byte
  TTFB: null,
  // custom: uix index page loaded
  XPL: (!isSSR && window.VLS_XPL) || 0,
  // custom: uix entrypoint loaded
  XEL: now(),
  // custom: render BootLoader (pre persist gate)
  XBL: null,
  // custom: render AppLoader (post persist gate)
  XAL: null,
  // custom: uix api/uix/init start
  XIS: null,
  // custom: api/uix/init done
  XID: null,
  // custom: core module chunk loaded
  XCL: null,
  // First Contentful Paint
  FCP: null,
  // custom: app running
  XAR: null,
  // Largest Contentful Paint
  // measures loading performance. To provide a good user experience,
  // LCP should occur within 2.5 seconds of when the page first starts loading.
  LCP: null,
  // First Input Delay
  // measures interactivity. To provide a good user experience,
  // pages should have a FID of 100 milliseconds or less.
  FID: null,
  // Cumulative Layout Shift
  // collected as percentage (and stored as statsd timing) instead of 0-1 ratio
  // measures visual stability. To provide a good user experience,
  // pages should maintain a CLS of 10% or less.
  CLS: null,
}

const jshs = () => (!isSSR ? performance.memory?.usedJSHeapSize || -1 : -1)
export const VITALS_MEMORY = {XEL: jshs(), XPL: 0}

export const setCustomVital = name => {
  if (!VITALS[name]) {
    // now() counts in ms from js engine start
    VITALS[name] = now()
    VITALS_MEMORY[name] = jshs()
    log.info('boot/%s: %o ms', name, parseInt(VITALS[name]))
  }
}

var send = false
function sendToServer(force = false) {
  // only if embedded in vls and prod
  if (process.env.VLS_DEPLOY !== 'vls' || process.env.NODE_ENV !== 'production') return

  if (send || (!force && values(VITALS).filter(isNil).length > 0)) return
  send = true
  let formData = new FormData()
  // add final SEND timestamp
  VITALS['XSEND'] = now()
  VITALS_MEMORY['XSEND'] = jshs()

  formData.set('data', JSON.stringify({timestamps: VITALS, memory: VITALS_MEMORY}))
  formData.set('isMobile', `${mobile()}`)
  navigator.sendBeacon('/api/uix/webvitals', formData)
}

export const registerWebVitals = () => {
  if (!(typeof window !== 'undefined' && window.navigator)) return

  let register = name => vital => {
    VITALS[name] = name == 'CLS' ? vital.value * 100 : vital.value
    VITALS_MEMORY[name] = jshs()
    sendToServer()
  }
  // FID will probably be reported last
  getFID(register('FID'))
  getFCP(register('FCP'))
  getTTFB(register('TTFB'))

  // also register intermediate values for CLS and LCP
  getCLS(register('CLS'), true)
  getLCP(register('LCP'), true)

  let forced_send_id = setInterval(() => {
    sendToServer(true)
    clearInterval(forced_send_id)
  }, FORCE_SECS * 1000)
}
